import ascending from "./ascending";

export default function(series) {
  return ascending(series).reverse();
}



//////////////////
// WEBPACK FOOTER
// ./~/vue-d3/~/d3-shape/src/order/descending.js
// module id = Q9Sa
// module chunks = 0